// Imports => Vendor
import axios from 'axios';

// Imports => API
import PublicationsAPI from '@api/publications.api';
import FaqsAPI from '@api/faqs.api';
import PagesAPI from '@api/pages.api';
import ThemesAPI from '@api/themes.api';
import CategoriesAPI from './categories.api';
import TermsAPI from './terms.api';

export class API {
  constructor(config, Store) {
    this.Store = Store;

    const Client = axios.create({
      ...config.api,
    });

    const PublicationsClient = axios.create({
      ...config.publications,
    });

    const ThemesClient = axios.create({
      ...config.themes,
    });

    this.publications = new PublicationsAPI({ Store, Client: PublicationsClient });
    this.faqs = new FaqsAPI({ Store, Client });
    this.pages = new PagesAPI({ Store, Client });
    this.themes = new ThemesAPI({ Store, Client: ThemesClient });
    this.categories = new CategoriesAPI({ Store, Client: Client });

    this.terms = new TermsAPI({ Store, Client: Client });
  }
}

export default API;
